import { parsePartySize } from "@/lib/parsePartySize";

// 空席確認 API (AvailabilityService.CheckAvailability) へ渡す予約条件。
// date は YYYY-MM-DD、time は HH:MM (GetReservationContext が分解済みの値をそのまま使う)。
export interface AvailabilityVisit {
  date: string;
  time: string;
  partySize: number;
}

// buildAvailabilityVisit は予約コンテキスト (GetReservationContext) から空席確認リクエストを
// 組み立てる。日時・人数のいずれかが欠ける (AI が抽出できなかった・人数を数値化できない) 場合は
// null を返し、呼び出し側でチップ非表示に使う。
export function buildAvailabilityVisit(
  preferredDate: string,
  preferredTime: string,
  preferredPartySize: string,
): AvailabilityVisit | null {
  const partySize = parsePartySize(preferredPartySize);
  if (preferredDate === "" || preferredTime === "" || partySize === null) return null;
  return { date: preferredDate, time: preferredTime, partySize };
}
